import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { motion } from "framer-motion";

import Logo from "./Logo";

type SyncLoadingMarkProps = {
  size?: number;
};

export function SyncLoadingMark({ size = 120 }: SyncLoadingMarkProps) {
  const innerRingSize = size * (100 / 120);
  const logoSize = size * (64 / 120);

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        height: size,
        justifyContent: "center",
        position: "relative",
        width: size,
      }}
    >
      <motion.div
        animate={{
          scale: [1, 0.9, 0.9, 1, 1],
          opacity: [1, 0.48, 0.48, 1, 1],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          repeatDelay: 1,
          repeat: Infinity,
        }}
        style={{ position: "relative", zIndex: 1 }}
      >
        <Logo disabledLink sx={{ width: logoSize, height: logoSize }} />
      </motion.div>

      <Box
        component={motion.div}
        animate={{
          scale: [1.2, 1, 1, 1.2, 1.2],
          rotate: [270, 0, 0, 270, 270],
          opacity: [0.25, 1, 1, 1, 0.25],
          borderRadius: ["25%", "25%", "50%", "50%", "25%"],
        }}
        transition={{ ease: "linear", duration: 3.2, repeat: Infinity }}
        sx={{
          width: innerRingSize,
          height: innerRingSize,
          borderRadius: "25%",
          position: "absolute",
          border: (theme) =>
            `solid 3px ${alpha(theme.palette.primary.dark, 0.24)}`,
        }}
      />

      <Box
        component={motion.div}
        animate={{
          scale: [1, 1.2, 1.2, 1, 1],
          rotate: [0, 270, 270, 0, 0],
          opacity: [1, 0.25, 0.25, 0.25, 1],
          borderRadius: ["25%", "25%", "50%", "50%", "25%"],
        }}
        transition={{
          ease: "linear",
          duration: 3.2,
          repeat: Infinity,
        }}
        sx={{
          width: size,
          height: size,
          borderRadius: "25%",
          position: "absolute",
          border: (theme) =>
            `solid 8px ${alpha(theme.palette.primary.dark, 0.24)}`,
        }}
      />
    </Box>
  );
}
